module.exports = __webpack_public_path__ + "img/logo-block-black-n.c0f439af.png";